<template>
    <div v-select-text="value" style="width: 800px; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px;">
       <table cellspacing="0" cellpadding="0" border="0" width="100%">
           <tbody>
           <tr>
               <td valign="top" width="250" style=" font-size: 18px; color: #36acff; font-weight:bold; padding-top: 40px; padding-right: 20px;">
                   <div style="padding: 4px;">Главная</div>
                   <div style="padding: 4px; border-top: 1px solid #efefef;">О нас</div>
                   <div style="padding: 4px; border-top: 1px solid #efefef;">Наши контакты</div>
                   <div style="padding: 4px; border-top: 1px solid #efefef;">Календарь</div>
                   <div style="padding: 4px; border-top: 1px solid #efefef;">События</div>

                   <div style="color: #a2d670; padding-top: 20px; margin-top: 20px; border-top: 1px solid #343434;">
                       <div style="padding: 4px;">По плану</div>
                       <div style="padding: 4px; border-top: 1px solid #efefef;">Награды</div>
                       <div style="padding: 4px; border-top: 1px solid #efefef;">Результаты</div>
                       <div style="padding: 4px; border-top: 1px solid #efefef; font-size: 15px;">Часто задаваемые вопросы</div>
                       <div style="padding: 4px; border-top: 1px solid #efefef;">Зарегистрироваться</div>
                   </div>
               </td>
               <td valign="top" style="font-size: 16px;">
                   <div class="title text-xs-center mb-4" style="color: #36acff;">Ежегодный праздник в Березовой роще</div>
                    <p class="redline">
                        По устоявшейся традиции, Сабантуй в Татарстане празднуется в несколько этапов, начиная с сел и районных центров. Финал праздника разворачивается в столице республики Казани. Местом проведения всенародно любимого фестиваля становится Березовая роща поселка Мирный на южной окраине татарской столицы. Здесь разворачивается площадь-майдан для народных гуляний, сцена для выступлений артистов, а также большая ярмарка с богатым выбором традиционных татарских блюд. Одним из самых ярких моментов казанского Сабантуя неизменно становятся соревнования по национальной борьбе «корэш». Финальная схватка двух сильнейших борцов-батыров считается кульминацией праздника. Впервые в спортивной программе Сабантуя – состязания силачей в поднятии гири, игра в городки, бег в мешках и скачки. По традиции столичный праздник проходит с 11:00 до 15:00 в Березовой роще, а позже продолжается большим эстрадным концертом в одном из центральных массовых учреждений Казани.
                    </p>
                   <p>
                       Мы приглашаем всех насладиться атмосферой праздника, национальной кухней и развлечениями в «Березовой роще».
                       Приходите с семьей!
                   </p>

                   <hr color="#36acff" size="1">

                   <div class="mt-4">
                       <strong>Дата: </strong>
                       <span>Среда, 15 июня</span>
                   </div>
                   <div>
                       <strong>Место: </strong>
                       <span>Поселок «Мирный», Приволжский район Казани</span>
                   </div>
                   <div>
                       <strong>Время: </strong>
                       <span>Начало в 8:00, окончание в 16:00</span>
                   </div>
                   <div>
                       <strong>Как добраться: </strong>
                       <span>выделены автобусы, которые будут курсировать от «ст. м. Пр. Победы» до «Березовой рощи». На электричке – со станции «Казань» до станции «Березовая роща».</span>
                   </div>

                   <div class="mt-4 mb-2 title" style="color: #36acff;">Специальные призы</div>
                   <ul style="margin-left: 20px;">
                        <li>Победители в «корэш» получают автомобиль за первое место, технику за второе и барана за третьей место</li>
                        <li>Розыгрыш призов за лучший национальный костюм</li>
                        <li>Детский конкурс «Лучший чтец на национальном языке» </li>
                   </ul>

               </td>
           </tr>
           </tbody>
       </table>
    </div>
</template>
<script>
    import SelectText from '@/directives/select-text.js'

    export default {
        props: {
            value: [Array]
        },
        directives: {
            SelectText
        }
    }
</script>
<style scoped></style>